import axios from "axios";

export default {
  name: "sales-contract",
  strict: true,
  state: {
    master: {},
    detailProduct: [],
    detailInvoice: [],
    document: [],
    manifestSc: [],
    approval: [],
    deletedDocument: [],
    newDocument: [],
    pageMode: String,
    supportDoc: [],
  },
  getters: {
    getMasterSC: state => {
      return state.master
    },
    getDetailProduct: state => {
      return state.detailProduct
    },
    getDetailInvoice: state => {
      return state.detailInvoice
    },
    getDocument: state => {
      return state.document
    },
    getNewDocument: state => {
      return state.newDocument
    },
    getDeletedDocument: state => {
      return state.deletedDocument
    },
    getManifestSC: state => {
      return state.manifestSc
    },
    getSupportDocSC: state => {
      return state.supportDoc
    },
  },
  mutations: {
    setMaster: (state, payload) => {
      let newAP = [];
      let sManager = [];

      payload.approval = newAP;
      payload.site_manager = sManager;
      state.master = payload;
    },
    setDetailProduct: (state, payload) => {
      state.detailProduct = payload
    },
    editDetailProduct: (state, payload) => {
      const source = [...state.detailProduct];

      let index;
      if (state.pageMode == 'Create') {
        if (payload.id == undefined){
          index = source.findIndex((data) => data.id_sc_dtl_product === payload.id_sc_dtl_product);
        }else{
          index = source.findIndex((data) => data.id === payload.id);
        }
      } else {
        index = source.findIndex((data) => data.id_sc_dtl_product === payload.id_sc_dtl_product);
      }


      if (index >= 0) {
        source[index] = payload
        state.detailProduct = source
      }
    },
    addDetailProduct: (state, payload) => {
      state.detailProduct.push(payload)
    },
    removeDetailProduct: (state, payload) => {
      const source = [...state.detailProduct];
      let index;
      if (state.pageMode == 'Create') {
        index = source.findIndex((data) => data.id === payload.id);
      } else {
        index = source.findIndex((data) => data.id_sc_dtl_product === payload.id_sc_dtl_product);
      }
      source.splice(index, 1);
      state.detailProduct = source
    },
    setInitialDetailInvoice: (state, payload) => {
      state.detailInvoice = payload
    },
    setDetailInvoice: (state, payload) => {
      state.detailInvoice.push(JSON.parse(JSON.stringify(payload)))
    },
    removeDetailInvoice: (state, payload) => {
      const source = [...state.detailInvoice];
      let index;
      console.log(state.pageMode)
      if (state.pageMode == 'Create') {
        index = source.findIndex((data) => data.id === payload.id);
      } else {
        index = source.findIndex((data) => data.id_sc_dtl_invoice === payload.id_sc_dtl_invoice);
        console.log(source,payload,"x")
      }
      source.splice(index, 1);
      state.detailInvoice = source
    },
    editingDetailInvoice: (state, payload) => {
      const source = [...state.detailInvoice];

      let index;
      if (state.pageMode == 'Create') {
        index = source.findIndex((data) => data.id === payload.id);
      } else {
        index = source.findIndex((data) => data.id_sc_dtl_invoice === payload.id_sc_dtl_invoice);
      }

      if (index >= 0) {
        source[index] = payload
        state.detailInvoice = source
      }
    },
    setDocument: (state, payload) => {
      state.document = [...state.document, payload]
    },
    setNewDocument: (state, payload) => {
      state.newDocument = [...state.newDocument, payload]
    },
    setInitialDocument: (state, payload) => {
      state.document = payload
    },
    removeDocument: (state, payload) => {
      const source = [...state.document];
      const index = source.findIndex((data) => data.id === payload.id);

      if (source[index].nama_file) {
        state.deletedDocument.push(source[index])
      }

      source.splice(index, 1);
      state.document = source
    },
    removeNewDocument: (state, payload) => {
      const source = [...state.newDocument];
      const index = source.findIndex((data) => data.id === payload.id);
      source.splice(index, 1);
      state.newDocument = source
    },
    setApproval: (state, payload) => {
      state.master.approval = payload
    },
    resetState: (state) => {
      state.detailProduct = [];
      state.detailInvoice = [];
      state.document = [];
      state.deletedDocument = [];
      state.newDocument = [];
    },
    setManifestSC: (state, payload) => {
      state.manifestSc = payload
    },
    setSupportDocSC: (state, payload) => {
      state.supportDoc = payload
    },
    setPageModeSalesContract: (state, payload) => {
      state.pageMode = payload
    }
  },
  actions: {
    getSalesContractList(store, { auth }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "sales_contract",
          auth: {
            username: auth.username,
            password: auth.password,
          },
          params: {
            tlc: auth.username
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getMasterCreate(store, { auth }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "sales_contract/data_input",
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            store.commit('setMaster', response.data)
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getDetailProduct(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "sales_contract/detail_product",
          auth: {
            username: auth.username,
            password: auth.password,
          },
          params: {
            sales_notification: params
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            let source = [];
            response.data.detail_product.forEach(data => {
              source.push({
                note: data.note,
                pn: data.pn,
                produk_name: data.produk_name,
                qty: data.qty,
                unit: data.unit,
                unit_price: 0,
                id_sc_dtl_product : data.id_sc_dtl_product
              })
            })
            store.commit('setDetailProduct', source)
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setDetailProduct(store, payload) {
      store.commit('setDetailProduct', payload)
    },
    editDetailProduct(store, payload) {
      store.commit('setPageModeSalesContract', payload)
      store.commit('editDetailProduct', payload.value);
    },
    addDetailProduct(store, payload) {
      store.commit("addDetailProduct", payload)
    },
    removeDetailProduct(store, payload) {
      store.commit('removeDetailProduct', payload)
    },
    setDetailInvoice(store, payload) {
      store.commit('setDetailInvoice', payload)
    },
    removeDetailInvoice(store, payload) {
      store.commit('removeDetailInvoice', payload)
    },
    editDetailInvoice(store, payload) {
      store.commit('setPageModeSalesContract', payload.mode);
      store.commit('editingDetailInvoice', payload.value);
    },
    setDocument(store, payload) {
      store.commit('setDocument', payload)
    },
    removeDocument(store, payload) {
      store.commit('removeDocument', payload)
    },
    setApproval(store, payload) {
      store.commit('setApproval', payload)
    },
    setPageModeSalesContract(store, payload) {
      store.commit('setPageModeSalesContract', payload)
      
    },
    postSalesContract(store, { auth, payload }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + "sales_contract",
          data: payload,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    postEditSalesContract(store, { auth, payload }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + "sales_contract/edit",
          data: payload,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    resetState(store) {
      store.commit("resetState")
    },
    getManifestSC(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "sales_contract",
          params: {
            tlc: auth.username,
            id_sales_contract: params.id
          },
          auth: {
            username: store.getters.getAuth.username,
            password: store.getters.getAuth.password,
          },
          headers: {
            "X-API-KEY": store.getters.getAuth.apikey,
          },
        })
          .then((response) => {
            store.commit('setManifestSC', response.data)
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    postManifestSC(store, { auth, payload }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + "sales_contract/approval",
          data: payload,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "application/json",
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    printManifestSC(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "sales_contract/cetak_sales_contract",
          responseType: "blob",
          params: {
            id_sales_contract: params,
          },
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response)
          })
          .catch((err) => {
            reject(err)
          });
      })
    },
    getEditSC(store, { auth, params }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "sales_contract/detail",
          auth: {
            username: auth.username,
            password: auth.password,
          },
          params: {
            id_sales_contract: params.id,
            tipe: params.type,
            tlc: auth.username
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            store.commit("setDetailProduct", response.data.detil_product);
            store.commit("setInitialDetailInvoice", response.data.detil_invoice);
            store.commit("setInitialDocument", response.data.document);
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    cancelTransactionSC(store, { auth, payload }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + "main/cancel_transaction",
          data: payload,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "application/json",
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    closeTransactionSC(store, { auth, payload }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: process.env.VUE_APP_SERVICEURL + "sales_contract/close_transaction",
          data: payload,
          auth: {
            username: auth.username,
            password: auth.password,
          },
          headers: {
            "X-API-KEY": auth.apikey,
            "Content-Type": "application/json",
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((err) => {
            console.log(err.response.data);
            reject(err);
          });
      });
    },
    getHistorySC(store, { auth, payload }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "sales_contract/amandemen_changes",
          auth: {
            username: auth.username,
            password: auth.password,
          },
          params: {
            id: payload
          },
          headers: {
            "X-API-KEY": auth.apikey,
          },
        })
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getSupportDocSC(store, { auth, id }) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_SERVICEURL + "termin/getdocumenttermin",
          params: {
            tlc: auth.username,
            id_termin: id
          },
          auth: {
            username: store.getters.getAuth.username,
            password: store.getters.getAuth.password,
          },
          headers: {
            "X-API-KEY": store.getters.getAuth.apikey,
          },
        })
          .then((response) => {
            store.commit('setSupportDocSC', response.data)
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
